// useIndexedDB.js
import { useEffect, useState } from "react";
import { indexedDBService } from "./indexedDBService";

export function useIndexedDB(collectionName) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      try {
        const all = await indexedDBService.getAll(collectionName);
        setItems(all);
      } catch (error) {
        console.error(`Failed to load data from ${collectionName}:`, error);
      } finally {
        setLoading(false);
      }
    }
    load();
  }, [collectionName]);

  const addItem = async (item) => {
    try {
      await indexedDBService.add(collectionName, item);
      setItems((prev) => [...prev, item]);
      console.log("added", item);
      console.log("Item added successfully!");
    } catch (error) {
      console.error(`Failed to add item to ${collectionName}:`, error);
    }
  };

  const updateItem = async (id, updatedData) => {
    try {
      await indexedDBService.update(collectionName, id, updatedData);
      setItems((prev) =>
        prev.map((item) =>
          item.id === id ? { ...item, ...updatedData } : item
        )
      );
    } catch (error) {
      console.error(`Failed to update item in ${collectionName}:`, error);
    }
  };

  const deleteItem = async (id) => {
    try {
      await indexedDBService.delete(collectionName, id);
      setItems((prev) => prev.filter((item) => item.id !== id));
    } catch (error) {
      console.error(`Failed to delete item from ${collectionName}:`, error);
    }
  };

  const getReceipts = async (month, year) => {
    try {
      const all = await indexedDBService.getAll(collectionName);
      const filtered = all.filter((item) => {
        if (!item.date) return false;
        const dateObj = new Date(item.date);
        return dateObj.getMonth() == month - 1 && dateObj.getFullYear() == year;
      });
      return filtered;
    } catch (error) {
      console.error(`Failed to get items from ${collectionName}:`, error);
      return [];
    }
  };

  return {
    items,
    loading,
    addItem,
    updateItem,
    deleteItem,
    getReceipts,
  };
}
